import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * In a single-page app the browser never announces a page change, so a screen
 * reader user hears nothing after activating a link. This reads the new
 * document title into a live region and moves focus to the main landmark.
 *
 * Skipped on first paint — the browser already announces the initial load.
 */
const RouteAnnouncer = () => {
  const { pathname } = useLocation();
  const [message, setMessage] = useState('');
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }

    /* Wait a frame so <Seo> has committed the new <title>. */
    const timer = window.setTimeout(() => {
      const title = document.title || 'New page';
      setMessage(`${title} — page loaded`);

      const main = document.getElementById('main-content');
      if (main) main.focus({ preventScroll: true });
    }, 120);

    return () => window.clearTimeout(timer);
  }, [pathname]);

  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  );
};

export default RouteAnnouncer;
